<template>
  <main class="skillfit">
    <section class="sub-hero">
      <div class="hero-wrap">
        <div class="sub-hero-copy">
          <p class="tag" data-i18n="skillfit-hero-eyebrow" v-html="$rt('skillfit-hero-eyebrow')"></p>
          <h1 class="hero-title">SkillFit</h1>
          <p class="hero-desc" data-i18n="skillfit-hero-desc-02" v-html="$rt('skillfit-hero-desc-02')"></p>
          <div class="hero-actions">
            <a class="btn btn-primary btn-lg" href="https://codepresso.io/home/contact">
              <span data-i18n="skillfit-hero-cta-primary" v-html="$rt('skillfit-hero-cta-primary')"></span>
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </a>
          </div>
        </div>

        <ul class="hero-facts surface-glass" data-stat-reveal="">
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H21C22.1046 19 23 18.1046 23 17V7C23 5.89543 22.1046 5 21 5Z" fill="var(--color-brand)"></path>
                <path d="M16 14.5H8C7.72386 14.5 7.5 14.7239 7.5 15V16C7.5 16.2761 7.72386 16.5 8 16.5H16C16.2761 16.5 16.5 16.2761 16.5 16V15C16.5 14.7239 16.2761 14.5 16 14.5Z" fill="var(--color-surface)"></path>
                <path d="M9 8.5H6C5.72386 8.5 5.5 8.72386 5.5 9V10.5C5.5 10.7761 5.72386 11 6 11H9C9.27614 11 9.5 10.7761 9.5 10.5V9C9.5 8.72386 9.27614 8.5 9 8.5Z" fill="var(--color-surface)"></path>
                <path d="M18 8.5H15C14.7239 8.5 14.5 8.72386 14.5 9V10.5C14.5 10.7761 14.7239 11 15 11H18C18.2761 11 18.5 10.7761 18.5 10.5V9C18.5 8.72386 18.2761 8.5 18 8.5Z" fill="var(--color-surface)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value"><span class="num" data-target="51">0</span><span class="unit">개</span></div>
              <p class="metric-card__label text-label" data-i18n="skillfit-hero-fact-label-01" v-html="$rt('skillfit-hero-fact-label-01')"></p>
            </div>
          </li>
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                <path d="M10.49 8H6.5C6.22386 8 6 8.22386 6 8.5V9.5C6 9.77614 6.22386 10 6.5 10H10.49C10.7661 10 10.99 9.77614 10.99 9.5V8.5C10.99 8.22386 10.7661 8 10.49 8Z" fill="var(--color-brand)"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 8.58579L17.293 6.29289L18.7072 7.70711L15.0001 11.4142L12.293 8.70711L13.7072 7.29289L15.0001 8.58579Z" fill="var(--color-brand-dark)"></path>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.0001 14.5858L17.293 12.2929L18.7072 13.7071L15.0001 17.4142L12.293 14.7071L13.7072 13.2929L15.0001 14.5858Z" fill="var(--color-brand-dark)"></path>
                <path d="M10.4998 14H6.50977C6.23362 14 6.00977 14.2239 6.00977 14.5V15.53C6.00977 15.8061 6.23362 16.03 6.50977 16.03H10.4998C10.7759 16.03 10.9998 15.8061 10.9998 15.53V14.5C10.9998 14.2239 10.7759 14 10.4998 14Z" fill="var(--color-brand)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value"><span class="num" data-target="4">0</span><span class="unit">가지</span></div>
              <p class="metric-card__label text-label" data-i18n="skillfit-hero-fact-label-02" v-html="$rt('skillfit-hero-fact-label-02')"></p>
            </div>
          </li>
          <li class="metric-card">
            <span class="hero-fact-icon icon-lg" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 18C2 18.5304 2.21074 19.0391 2.58582 19.4142C2.96089 19.7893 3.46957 20 4 20H20C20.5304 20 21.0392 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8H2V18Z" fill="color-mix(in srgb, var(--color-brand) 35%, var(--color-surface))"></path>
                <path d="M19.9996 3H3.99957C3.40568 3.07282 2.86389 3.37521 2.49011 3.84244C2.11633 4.30966 1.94025 4.90461 1.99957 5.5V8H21.9996V5.5C22.0563 4.90512 21.8793 4.31152 21.506 3.84489C21.1327 3.37827 20.5924 3.07525 19.9996 3Z" fill="var(--color-brand)"></path>
                <path d="M16 4.5H15C14.7239 4.5 14.5 4.72386 14.5 5V6C14.5 6.27614 14.7239 6.5 15 6.5H16C16.2761 6.5 16.5 6.27614 16.5 6V5C16.5 4.72386 16.2761 4.5 16 4.5Z" fill="var(--color-surface)"></path>
                <path d="M12.5 4.5H11.5C11.2239 4.5 11 4.72386 11 5V6C11 6.27614 11.2239 6.5 11.5 6.5H12.5C12.7761 6.5 13 6.27614 13 6V5C13 4.72386 12.7761 4.5 12.5 4.5Z" fill="var(--color-surface)"></path>
                <path d="M19.5 4.5H18.5C18.2239 4.5 18 4.72386 18 5V6C18 6.27614 18.2239 6.5 18.5 6.5H19.5C19.7761 6.5 20 6.27614 20 6V5C20 4.72386 19.7761 4.5 19.5 4.5Z" fill="var(--color-surface)"></path>
              </svg>
            </span>
            <div>
              <div class="metric-card__value"><span class="num" data-target="0">0</span><span class="unit">개</span></div>
              <p class="metric-card__label text-label" data-i18n="skillfit-hero-fact-label-03" v-html="$rt('skillfit-hero-fact-label-03')"></p>
            </div>
          </li>
        </ul>
      </div>
    </section>

    <section class="intro pain-section fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <h3 data-i18n="skillfit-intro-title" v-html="$rt('skillfit-intro-title')"></h3>
          <p class="desc" data-i18n="skillfit-intro-desc" v-html="$rt('skillfit-intro-desc')"></p>
        </div>
        <div class="section-content">
          <ul class="pain-grid">
            <li class="pain-card pain-card--detail">
              <span class="pain-card__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M6 9C7.06087 9 8.07827 9.42142 8.82841 10.1716C9.57856 10.9217 10 11.9391 10 13V18C10 18.2652 9.89464 18.5196 9.70711 18.7071C9.51957 18.8946 9.26522 19 9 19H3C2.73478 19 2.48043 18.8946 2.29289 18.7071C2.10536 18.5196 2 18.2652 2 18V13C2 11.9391 2.42142 10.9217 3.17157 10.1716C3.92172 9.42142 4.93913 9 6 9Z" fill="currentColor"></path>
                  <path d="M6 8C7.38071 8 8.5 6.88071 8.5 5.5C8.5 4.11929 7.38071 3 6 3C4.61929 3 3.5 4.11929 3.5 5.5C3.5 6.88071 4.61929 8 6 8Z" fill="currentColor"></path>
                  <path d="M21 19H15C14.7348 19 14.4804 18.8946 14.2929 18.7071C14.1053 18.5196 14 18.2652 14 18V13C14 11.9391 14.4214 10.9217 15.1716 10.1716C15.9217 9.42142 16.9391 9 18 9C19.0609 9 20.0783 9.42142 20.8284 10.1716C21.5786 13.9217 22 14.9391 22 13V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19Z" fill="currentColor"></path>
                  <path d="M18 8C19.3807 8 20.5 6.88071 20.5 5.5C20.5 4.11929 19.3807 3 18 3C16.6193 3 15.5 4.11929 15.5 5.5C15.5 6.88071 16.6193 8 18 8Z" fill="currentColor"></path>
                  <path d="M11.1201 12H12.8701C13.931 12 14.9484 12.4214 15.6985 13.1716C16.4487 13.9217 16.8701 14.9391 16.8701 16V21C16.8701 21.2652 16.7648 21.5196 16.5772 21.7071C16.3897 21.8946 16.1353 22 15.8701 22H8.12012C7.8549 22 7.60055 21.8946 7.41301 21.7071C7.22547 21.5196 7.12012 21.2652 7.12012 21V16C7.12012 14.9391 7.54154 13.9217 8.29169 13.1716C9.04183 12.4214 10.0593 12 11.1201 12Z" fill="currentColor"></path>
                  <path d="M12 11C13.3807 11 14.5 9.88071 14.5 8.5C14.5 7.11929 13.3807 6 12 6C10.6193 6 9.5 7.11929 9.5 8.5C9.5 9.88071 10.6193 11 12 11Z" fill="currentColor"></path>
                </svg>
              </span>
              <p class="pain-card__title" data-i18n="skillfit-intro-item-title-01" v-html="$rt('skillfit-intro-item-title-01')"></p>
              <p data-i18n="skillfit-intro-item-desc-01" v-html="$rt('skillfit-intro-item-desc-01')"></p>
            </li>
            <li class="pain-card pain-card--detail">
              <span class="pain-card__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M18 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2Z" fill="currentColor"></path>
                  <path d="M16.5 7H7.5M16.5 12H7.5M16.5 16H7.5" stroke="var(--color-surface)" stroke-width="2" stroke-linecap="round"></path>
                </svg>
              </span>
              <p class="pain-card__title" data-i18n="skillfit-intro-item-title-02" v-html="$rt('skillfit-intro-item-title-02')"></p>
              <p data-i18n="skillfit-intro-item-desc-02" v-html="$rt('skillfit-intro-item-desc-02')"></p>
            </li>
            <li class="pain-card pain-card--detail">
              <span class="pain-card__icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M21 5H3C1.89543 5 1 5.89543 1 7V17C1 18.1046 1.89543 19 3 19H21C22.1046 19 23 18.1046 23 17V7C23 5.89543 22.1046 5 21 5Z" fill="currentColor"></path>
                  <path d="M5 15.5H19M5 8.5H19M5 12H19" stroke="var(--color-surface)" stroke-width="1.5" stroke-linecap="round" stroke-dasharray="1 2.5"></path>
                </svg>
              </span>
              <p class="pain-card__title" data-i18n="skillfit-intro-item-title-03" v-html="$rt('skillfit-intro-item-title-03')"></p>
              <p data-i18n="skillfit-intro-item-desc-03" v-html="$rt('skillfit-intro-item-desc-03')"></p>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="journey is-sunken fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skillfit-journey-tag" v-html="$rt('skillfit-journey-tag')"></p>
          <h2 data-i18n="skillfit-journey-title" v-html="$rt('skillfit-journey-title')"></h2>
          <p class="desc" data-i18n="skillfit-journey-desc" v-html="$rt('skillfit-journey-desc')"></p>
        </div>
        <div class="section-content">
          <ol class="cycle">
            <li>
              <div class="cycle-head">
                <span class="cycle-no">1</span>
                <p class="cycle-en" data-i18n="skillfit-journey-item-en-01" v-html="$rt('skillfit-journey-item-en-01')"></p>
              </div>
              <h3 data-i18n="skillfit-journey-item-title-01" v-html="$rt('skillfit-journey-item-title-01')"></h3>
              <p class="description" data-i18n="skillfit-journey-item-desc-01" v-html="$rt('skillfit-journey-item-desc-01')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li>
              <div class="cycle-head">
                <span class="cycle-no">2</span>
                <p class="cycle-en" data-i18n="skillfit-journey-item-en-02" v-html="$rt('skillfit-journey-item-en-02')"></p>
              </div>
              <h3 data-i18n="skillfit-journey-item-title-02" v-html="$rt('skillfit-journey-item-title-02')"></h3>
              <p class="description" data-i18n="skillfit-journey-item-desc-02" v-html="$rt('skillfit-journey-item-desc-02')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li>
              <div class="cycle-head">
                <span class="cycle-no">3</span>
                <p class="cycle-en" data-i18n="skillfit-journey-item-en-03" v-html="$rt('skillfit-journey-item-en-03')"></p>
              </div>
              <h3 data-i18n="skillfit-journey-item-title-03" v-html="$rt('skillfit-journey-item-title-03')"></h3>
              <p class="description" data-i18n="skillfit-journey-item-desc-03" v-html="$rt('skillfit-journey-item-desc-03')"></p>
              <span class="cycle-arrow" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
              </span>
            </li>
            <li>
              <div class="cycle-head">
                <span class="cycle-no">4</span>
                <p class="cycle-en" data-i18n="skillfit-journey-item-en-04" v-html="$rt('skillfit-journey-item-en-04')"></p>
              </div>
              <h3 data-i18n="skillfit-journey-item-title-04" v-html="$rt('skillfit-journey-item-title-04')"></h3>
              <p class="description" data-i18n="skillfit-journey-item-desc-04" v-html="$rt('skillfit-journey-item-desc-04')"></p>
            </li>
          </ol>

        </div>
      </div>
    </section>

    <section class="deliverables product-feature fade-up">
      <div class="section-wrap row">
        <div class="feature-copy">
          <p class="tag" data-i18n="skillfit-deliverables-tag-01" v-html="$rt('skillfit-deliverables-tag-01')"></p>
          <h2 data-i18n="skillfit-deliverables-title-01" v-html="$rt('skillfit-deliverables-title-01')"></h2>
          <p class="desc" data-i18n="skillfit-deliverables-desc-01" v-html="$rt('skillfit-deliverables-desc-01')"></p>
          <ul class="feature-points">
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-01-01" v-html="$rt('skillfit-deliverables-point-01-01')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-01-02" v-html="$rt('skillfit-deliverables-point-01-02')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-01-03" v-html="$rt('skillfit-deliverables-point-01-03')"></span>
            </li>
          </ul>
        </div>
        <div class="content-panel bg">
          <div class="preview-frame preview-frame--flush">
            <img src="/images/mockups/skillfit-learning-path.png" alt="Python 트랙의 초급·중급·전문가 학습 경로와 초급 진행률 12%를 보여주는 화면" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="catalog is-sunken fade-up" id="skillfit-tracks">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skillfit-catalog-tag" v-html="$rt('skillfit-catalog-tag')"></p>
          <h2 data-i18n="skillfit-catalog-title" v-html="$rt('skillfit-catalog-title')"></h2>
          <p class="desc" data-i18n="skillfit-catalog-desc" v-html="$rt('skillfit-catalog-desc')"></p>
        </div>
        <div class="section-content track-flow" aria-label="대표 학습 트랙">
          <ul class="track-grid skillfit-track-rail">
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-01" v-html="$rt('skillfit-catalog-track-tag-01')"></p>
                <span class="track-card__mark" aria-hidden="true"><img src="/images/icons/track/tensorflow.png" alt="" width="32" height="32" loading="lazy"></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-01" v-html="$rt('skillfit-catalog-track-title-01')"></h3>
            </li>
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-02" v-html="$rt('skillfit-catalog-track-tag-02')"></p>
                <span class="track-card__mark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M13.796 0a6.93 6.93 0 0 0-4.91 2.019L5.451 5.455l3.273 3.27 3.432-3.432a2.284 2.284 0 0 1 3.277 0 2.28 2.28 0 0 1 0 3.275L12 12.001l3.273 3.273 3.433-3.435c2.692-2.692 2.692-7.127 0-9.82A6.92 6.92 0 0 0 13.796 0m-5.07 8.728-3.433 3.434c-2.692 2.693-2.692 7.126 0 9.819A6.92 6.92 0 0 0 10.203 24a6.93 6.93 0 0 0 4.911-2.02l3.432-3.432-3.271-3.272-3.433 3.433a2.284 2.284 0 0 1-3.277 0 2.28 2.28 0 0 1 0-3.276L12 12z"></path></svg></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-02" v-html="$rt('skillfit-catalog-track-title-02')"></h3>
            </li>
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-03" v-html="$rt('skillfit-catalog-track-tag-03')"></p>
                <span class="track-card__mark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M12.005 0L4.952 7.053a9.865 9.865 0 000 14.022 9.866 9.866 0 0014.022 0c3.984-3.9 3.986-10.205.085-14.023l-1.744 1.743c2.904 2.905 2.904 7.634 0 10.538s-7.634 2.904-10.538 0-2.904-7.634 0-10.538l4.647-4.646.582-.665zm3.568 3.899a1.327 1.327 0 00-1.327 1.327 1.327 1.327 0 001.327 1.328A1.327 1.327 0 0016.9 5.226 1.327 1.327 0 0015.573 3.9z"></path></svg></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-03" v-html="$rt('skillfit-catalog-track-title-03')"></h3>
            </li>
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-04" v-html="$rt('skillfit-catalog-track-tag-04')"></p>
                <span class="track-card__mark" aria-hidden="true"><img src="/images/icons/track/ai-agent.png" alt="" width="32" height="32" loading="lazy"></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-04" v-html="$rt('skillfit-catalog-track-title-04')"></h3>
            </li>
          </ul>

          <ul class="track-grid skillfit-track-rail skillfit-track-rail--reverse">
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-05" v-html="$rt('skillfit-catalog-track-tag-05')"></p>
                <span class="track-card__mark" aria-hidden="true"><img src="/images/icons/track/python.png" alt="" width="32" height="32" loading="lazy"></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-05" v-html="$rt('skillfit-catalog-track-title-05')"></h3>
            </li>
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-06" v-html="$rt('skillfit-catalog-track-tag-06')"></p>
                <span class="track-card__mark" aria-hidden="true"><svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M11.915 0 11.7.215C9.515 2.4 7.47 6.39 6.046 10.483c-1.064 1.024-3.633 2.81-3.711 3.551-.093.87 1.746 2.611 1.55 3.235-.198.625-1.304 1.408-1.014 1.939.1.188.823.011 1.277-.491a13.389 13.389 0 0 0-.017 2.14c.076.906.27 1.668.643 2.232.372.563.956.911 1.667.911.397 0 .727-.114 1.024-.264.298-.149.571-.33.91-.5.68-.34 1.634-.666 3.53-.604 1.903.062 2.872.39 3.559.704.687.314 1.15.664 1.925.664.767 0 1.395-.336 1.807-.9.412-.563.631-1.33.72-2.24.06-.623.055-1.32 0-2.066.454.45 1.117.604 1.213.424.29-.53-.816-1.314-1.013-1.937-.198-.624 1.642-2.366 1.549-3.236-.08-.748-2.707-2.568-3.748-3.586C16.428 6.374 14.308 2.394 12.13.215zm.175 6.038a2.95 2.95 0 0 1 2.943 2.942 2.95 2.95 0 0 1-2.943 2.943A2.95 2.95 0 0 1 9.148 8.98a2.95 2.95 0 0 1 2.942-2.942zM8.685 7.983a3.515 3.515 0 0 0-.145.997c0 1.951 1.6 3.55 3.55 3.55 1.95 0 3.55-1.598 3.55-3.55 0-.329-.046-.648-.132-.951.334.095.64.208.915.336a42.699 42.699 0 0 1 2.042 5.829c.678 2.545 1.01 4.92.846 6.607-.082.844-.29 1.51-.606 1.94-.315.431-.713.651-1.315.651-.593 0-.932-.27-1.673-.61-.741-.338-1.825-.694-3.792-.758-1.974-.064-3.073.293-3.821.669-.375.188-.659.373-.911.5s-.466.2-.752.2c-.53 0-.876-.209-1.16-.64-.285-.43-.474-1.101-.545-1.948-.141-1.693.176-4.069.823-6.614a43.155 43.155 0 0 1 1.934-5.783c.348-.167.749-.31 1.192-.425zm-3.382 4.362a.216.216 0 0 1 .13.031c-.166.56-.323 1.116-.463 1.665a33.849 33.849 0 0 0-.547 2.555 3.9 3.9 0 0 0-.2-.39c-.58-1.012-.914-1.642-1.16-2.08.315-.24 1.679-1.755 2.24-1.781zm13.394.01c.562.027 1.926 1.543 2.24 1.783-.246.438-.58 1.068-1.16 2.08a4.428 4.428 0 0 0-.163.309 32.354 32.354 0 0 0-.562-2.49 40.579 40.579 0 0 0-.482-1.652.216.216 0 0 1 .127-.03z"></path></svg></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-06" v-html="$rt('skillfit-catalog-track-title-06')"></h3>
            </li>
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-07" v-html="$rt('skillfit-catalog-track-tag-07')"></p>
                <span class="track-card__mark" aria-hidden="true"><img src="/images/icons/track/springboot.png" alt="" width="32" height="32" loading="lazy"></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-07" v-html="$rt('skillfit-catalog-track-title-07')"></h3>
            </li>
            <li class="track-card">
              <div class="track-card__head">
                <p class="tag" data-i18n="skillfit-catalog-track-tag-08" v-html="$rt('skillfit-catalog-track-tag-08')"></p>
                <span class="track-card__mark" aria-hidden="true"><img src="/images/icons/track/git.png" alt="" width="32" height="32" loading="lazy"></span>
              </div>
              <h3 data-i18n="skillfit-catalog-track-title-08" v-html="$rt('skillfit-catalog-track-title-08')"></h3>
            </li>
          </ul>
        </div>
      </div>
    </section>

    <section class="deliverables product-feature fade-up">
      <div class="section-wrap row">
        <div class="feature-copy">
          <p class="tag" data-i18n="skillfit-deliverables-tag-02" v-html="$rt('skillfit-deliverables-tag-02')"></p>
          <h2 data-i18n="skillfit-deliverables-title-02" v-html="$rt('skillfit-deliverables-title-02')"></h2>
          <p class="desc" data-i18n="skillfit-deliverables-desc-02" v-html="$rt('skillfit-deliverables-desc-02')"></p>
          <ul class="feature-points">
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-02-01" v-html="$rt('skillfit-deliverables-point-02-01')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-02-02" v-html="$rt('skillfit-deliverables-point-02-02')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-02-03" v-html="$rt('skillfit-deliverables-point-02-03')"></span>
            </li>
          </ul>
        </div>
        <div class="content-panel bg">
          <div class="preview-frame preview-frame--flush">
            <img src="/images/mockups/skillfit-code-floating.png" alt="학습 안내 위에 AI 프롬프트와 생성된 Python 코드·실행 결과 창이 겹쳐진 화면" loading="lazy">
          </div>
        </div>
      </div>
    </section>

    <section class="deliverables product-feature is-sunken fade-up">
      <div class="section-wrap row">
        <div class="feature-copy">
          <p class="tag" data-i18n="skillfit-deliverables-tag-03" v-html="$rt('skillfit-deliverables-tag-03')"></p>
          <h2 data-i18n="skillfit-deliverables-title-03" v-html="$rt('skillfit-deliverables-title-03')"></h2>
          <p class="desc" data-i18n="skillfit-deliverables-desc-03" v-html="$rt('skillfit-deliverables-desc-03')"></p>
          <ul class="feature-points">
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-03-01" v-html="$rt('skillfit-deliverables-point-03-01')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-03-02" v-html="$rt('skillfit-deliverables-point-03-02')"></span>
            </li>
            <li>
              <img src="/images/icons/service/ic_check_round.svg" alt="" aria-hidden="true">
              <span data-i18n="skillfit-deliverables-point-03-03" v-html="$rt('skillfit-deliverables-point-03-03')"></span>
            </li>
          </ul>
        </div>
        <div class="content-panel bg">
          <div class="preview-frame preview-frame--flush">
            <img src="/images/mockups/skillfit-tutor-floating.png" alt="RICJ 학습 화면 위에 AI 튜터의 질문과 답변 대화창이 떠 있는 화면" loading="lazy">
          </div>
        </div>

        <div class="summary-banner dark">
          <div class="bridge-inner">
            <div class="bridge-copy">
              <p class="bridge-title" data-i18n="skillfit-statement-title" v-html="$rt('skillfit-statement-title')"></p>
              <p class="bridge-desc" data-i18n="skillfit-statement-desc" v-html="$rt('skillfit-statement-desc')"></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="features fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skillfit-features-tag" v-html="$rt('skillfit-features-tag')"></p>
          <h2 data-i18n="skillfit-features-title" v-html="$rt('skillfit-features-title')"></h2>
          <p class="desc" data-i18n="skillfit-features-desc" v-html="$rt('skillfit-features-desc')"></p>
        </div>
        <div class="section-content">
          <div class="feature-card-grid">
            <article class="feature-card">
              <div class="feature-card-icon-row">
                <span class="feature-card-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19.5 4.01953H4.5C3.39543 4.01953 2.5 4.91496 2.5 6.01953V19.0195C2.5 20.1241 3.39543 21.0195 4.5 21.0195H19.5C20.6046 21.0195 21.5 20.1241 21.5 19.0195V6.01953C21.5 4.91496 20.6046 4.01953 19.5 4.01953Z" fill="var(--color-brand)"></path>
                    <path d="M8.48001 3.01953H7.5C7.22386 3.01953 7 3.24339 7 3.51953V5.51953C7 5.79567 7.22386 6.01953 7.5 6.01953H8.48001C8.75615 6.01953 8.98001 5.79567 8.98001 5.51953V3.51953C8.98001 3.24339 8.75615 3.01953 8.48001 3.01953Z" fill="var(--color-brand-dark)"></path>
                    <path d="M16.5 3.01953H15.5C15.2239 3.01953 15 3.24339 15 3.51953V5.51953C15 5.79567 15.2239 6.01953 15.5 6.01953H16.5C16.7761 6.01953 17 5.79567 17 5.51953V3.51953C17 3.24339 16.7761 3.01953 16.5 3.01953Z" fill="var(--color-brand-dark)"></path>
                    <path d="M8.74023 9.5H7.24023C6.96409 9.5 6.74023 9.72386 6.74023 10V11.5C6.74023 11.7761 6.96409 12 7.24023 12H8.74023C9.01638 12 9.24023 11.7761 9.24023 11.5V10C9.24023 9.72386 9.01638 9.5 8.74023 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M12.75 9.5H11.25C10.9739 9.5 10.75 9.72386 10.75 10V11.5C10.75 11.7761 10.9739 12 11.25 12H12.75C13.0261 12 13.25 11.7761 13.25 11.5V10C13.25 9.72386 13.0261 9.5 12.75 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M16.7598 9.5H15.2598C14.9836 9.5 14.7598 9.72386 14.7598 10V11.5C14.7598 11.7761 14.9836 12 15.2598 12H16.7598C17.0359 12 17.2598 11.7761 17.2598 11.5V10C17.2598 9.72386 17.0359 9.5 16.7598 9.5Z" fill="var(--color-surface)"></path>
                    <path d="M8.74023 14H7.24023C6.96409 14 6.74023 14.2239 6.74023 14.5V16C6.74023 16.2761 6.96409 16.5 7.24023 16.5H8.74023C9.01638 16.5 9.24023 16.2761 9.24023 16V14.5C9.24023 14.2239 9.01638 14 8.74023 14Z" fill="var(--color-surface)"></path>
                    <path d="M12.75 14H11.25C10.9739 14 10.75 14.2239 10.75 14.5V16C10.75 16.2761 10.9739 16.5 11.25 16.5H12.75C13.0261 16.5 13.25 16.2761 13.25 16V14.5C13.25 14.2239 13.0261 14 12.75 14Z" fill="var(--color-surface)"></path>
                    <path d="M16.7598 14H15.2598C14.9836 14 14.7598 14.2239 14.7598 14.5V16C14.7598 16.2761 14.9836 16.5 15.2598 16.5H16.7598C17.0359 16.5 17.2598 16.2761 17.2598 16V14.5C17.2598 14.2239 17.0359 14 16.7598 14Z" fill="var(--color-surface)"></path>
                  </svg>
                </span>
              </div>
              <div class="content-panel__intro">
                <p class="mini-title-sm" data-i18n="skillfit-features-item-title-01" v-html="$rt('skillfit-features-item-title-01')"></p>
                <h3 data-i18n="skillfit-features-item-subtitle-01" v-html="$rt('skillfit-features-item-subtitle-01')"></h3>
                <p class="desc" data-i18n="skillfit-features-item-desc-01" v-html="$rt('skillfit-features-item-desc-01')"></p>
              </div>
            </article>

            <article class="feature-card">
              <div class="feature-card-icon-row">
                <span class="feature-card-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 18C2 18.5304 2.21074 19.0391 2.58582 19.4142C2.96089 19.7893 3.46957 20 4 20H20C20.5304 20 21.0392 19.7893 21.4142 19.4142C21.7893 19.0391 22 18.5304 22 18V8H2V18Z" fill="color-mix(in srgb, var(--color-brand) 22%, var(--color-surface))"></path>
                    <path d="M19.9996 3H3.99957C3.40568 3.07282 2.86389 3.37521 2.49011 3.84244C2.11633 4.30966 1.94025 4.90461 1.99957 5.5V8H21.9996V5.5C22.0563 4.90512 21.8793 4.31152 21.506 3.84489C21.1327 3.37827 20.5924 3.07525 19.9996 3Z" fill="var(--color-brand)"></path>
                    <path d="M16 4.5H15C14.7239 4.5 14.5 4.72386 14.5 5V6C14.5 6.27614 14.7239 6.5 15 6.5H16C16.2761 6.5 16.5 6.27614 16.5 6V5C16.5 4.72386 16.2761 4.5 16 4.5Z" fill="var(--color-surface)"></path>
                    <path d="M12.5 4.5H11.5C11.2239 4.5 11 4.72386 11 5V6C11 6.27614 11.2239 6.5 11.5 6.5H12.5C12.7761 6.5 13 6.27614 13 6V5C13 4.72386 12.7761 4.5 12.5 4.5Z" fill="var(--color-surface)"></path>
                    <path d="M19.5 4.5H18.5C18.2239 4.5 18 4.72386 18 5V6C18 6.27614 18.2239 6.5 18.5 6.5H19.5C19.7761 6.5 20 6.27614 20 6V5C20 4.72386 19.7761 4.5 19.5 4.5Z" fill="var(--color-surface)"></path>
                  </svg>
                </span>
              </div>
              <div class="content-panel__intro">
                <p class="mini-title-sm" data-i18n="skillfit-features-item-title-02" v-html="$rt('skillfit-features-item-title-02')"></p>
                <h3 data-i18n="skillfit-features-item-subtitle-02" v-html="$rt('skillfit-features-item-subtitle-02')"></h3>
                <p class="desc" data-i18n="skillfit-features-item-desc-02" v-html="$rt('skillfit-features-item-desc-02')"></p>
              </div>
            </article>

            <article class="feature-card">
              <div class="feature-card-icon-row">
                <span class="feature-card-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 7V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58578 21.4142C4.21071 21.0391 4 20.5304 4 20V4C4 3.46957 4.21071 2.96083 4.58578 2.58575C4.96086 2.21068 5.46957 2 6 2H15L20 7Z" fill="var(--color-brand)"></path>
                    <path d="M16 7H20L15 2V6C15 6.26522 15.1054 6.51956 15.2929 6.70709C15.4804 6.89463 15.7348 7 16 7Z" fill="color-mix(in srgb, var(--color-brand) 25%, var(--color-surface))"></path>
                    <path d="M16.5 11H7.5M16.5 15H7.5" stroke="var(--color-surface)" stroke-width="2" stroke-linecap="round"></path>
                  </svg>
                </span>
              </div>
              <div class="content-panel__intro">
                <p class="mini-title-sm">원클릭 성과 리포트</p>
                <h3>실시간 조회는 물론 <br> 엑셀 다운로드까지 한 번에</h3>
                <p class="desc">기수 종료와 동시에 개인별 상세 리포트와 조직별 성과 요약을 확인하고, 파일로 내려받아 보관할 수 있습니다.</p>
              </div>
            </article>

          </div>
        </div>
      </div>
    </section>

    <section class="process fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title" data-i18n="skillfit-process-tag" v-html="$rt('skillfit-process-tag')"></p>
          <h2 data-i18n="skillfit-process-title" v-html="$rt('skillfit-process-title')"></h2>
          <p class="desc" data-i18n="skillfit-process-desc" v-html="$rt('skillfit-process-desc')"></p>
        </div>
        <div class="section-content">
          <ol class="timeline">
            <li>
              <span class="timeline__term" data-i18n="skillfit-process-item-term-01" v-html="$rt('skillfit-process-item-term-01')"></span>
              <span class="timeline__marker" aria-hidden="true"></span>
              <div class="timeline__body">
                <h3 class="timeline__title" data-i18n="skillfit-process-item-title-01" v-html="$rt('skillfit-process-item-title-01')"></h3>
                <p class="timeline__desc" data-i18n="skillfit-process-item-desc-01" v-html="$rt('skillfit-process-item-desc-01')"></p>
              </div>
            </li>
            <li>
              <span class="timeline__term" data-i18n="skillfit-process-item-term-02" v-html="$rt('skillfit-process-item-term-02')"></span>
              <span class="timeline__marker" aria-hidden="true"></span>
              <div class="timeline__body">
                <h3 class="timeline__title" data-i18n="skillfit-process-item-title-02" v-html="$rt('skillfit-process-item-title-02')"></h3>
                <p class="timeline__desc" data-i18n="skillfit-process-item-desc-02" v-html="$rt('skillfit-process-item-desc-02')"></p>
              </div>
            </li>
            <li>
              <span class="timeline__term">2~3주</span>
              <span class="timeline__marker" aria-hidden="true"></span>
              <div class="timeline__body">
                <h3 class="timeline__title">학습과 실습</h3>
                <p class="timeline__desc">학습자는 계획대로 실습을 진행하고, 담당자는 대시보드로 진행 상황을 봅니다.</p>
              </div>
            </li>
            <li>
              <span class="timeline__term">종료 시</span>
              <span class="timeline__marker" aria-hidden="true"></span>
              <div class="timeline__body">
                <h3 class="timeline__title">리포트 전달</h3>
                <p class="timeline__desc">개인 리포트와 조직 요약을 전달하고, 다음 기수 범위를 함께 정합니다.</p>
              </div>
            </li>
          </ol>
        </div>
      </div>
    </section>

    <section class="faq is-sunken fade-up">
      <div class="section-wrap col">
        <div class="section-title text-center">
          <p class="mini-title">FAQ</p>
          <h2>시작 전에 많이 묻는 질문</h2>
        </div>
        <div class="section-content">
          <div class="faq-list">
            <details>
              <summary class="faq-list__question">
                사전 지식이 없어도 되나요?
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer">네. 진단 인터뷰가 현재 수준을 먼저 확인하고 초급 레벨부터 학습 경로를 제안합니다. 이미 아는 영역은 건너뛸 수 있습니다.</p>
            </details>
            <details>
              <summary class="faq-list__question">
                하루에 얼마나 써야 하나요?
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer">하루 30분에서 1시간을 기준으로 2~3주 계획을 만듭니다. 스킬 단위로 끊어져 있어 시간이 날 때 한 스킬씩 진행할 수 있습니다.</p>
            </details>
            <details>
              <summary class="faq-list__question">
                설치할 프로그램이 있나요?
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer">없습니다. 학습부터 실습·채점까지 모두 브라우저에서 이뤄지므로 별도 프로그램을 설치하거나 설정할 필요가 없습니다.</p>
            </details>
            <details>
              <summary class="faq-list__question">
                어떤 언어와 기술을 다루나요?
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer">Python · Java · JavaScript · C++ · SQL · Git · Linux 같은 기본기부터 프롬프트 엔지니어링 · LangChain · LangGraph · PyTorch · TensorFlow까지 51개 트랙을 제공합니다.</p>
            </details>
            <details>
              <summary class="faq-list__question">
                진단 결과가 정확한가요?
                <span class="faq-list__icon" aria-hidden="true">
                  <svg class="icon-sm" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                </span>
              </summary>
              <p class="faq-list__answer">대화형 진단의 첫 결과는 학습을 시작하기 위한 기준입니다. 이후 정답률과 제출 코드가 반영되면서 학습 경로를 계속 조정합니다.</p>
            </details>
          </div>
        </div>
      </div>
    </section>

    <section class="cta-final fade-up">
      <div class="section-wrap col cta-final-inner">
        <h2 class="cta-final-title">2~3주 뒤, 구성원의 실력 변화를 확인하세요</h2>
        <p class="cta-final-desc">대상자 명단과 기간만 알려주시면 기수를 만들어 드립니다.</p>
        <div class="cta-final-actions">
          <a class="btn btn-primary btn-lg" href="https://codepresso.io/home/contact">
            체험 프로그램 신청
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M9 18L15 12L9 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          </a>
        </div>
      </div>
    </section>
  </main>

  <ClientInteractions :scripts='["js/fade-up.js","js/header-scroll.js","js/nav-menu.js","js/stat-reveal.js"]' />
</template>

<script setup lang="ts">
import ClientInteractions from '../components/ClientInteractions.vue'
import { useRenewalText } from '../composables/useRenewalText'
import ko from '../data/i18n-dist/Skillfit/ko.json'
import en from '../data/i18n-dist/Skillfit/en.json'
import ja from '../data/i18n-dist/Skillfit/ja.json'
import vi from '../data/i18n-dist/Skillfit/vi.json'
import es from '../data/i18n-dist/Skillfit/es.json'

// 문자열은 data/i18n-dist 에서 온다 — 마크업은 키만 들고 있다.
const $rt = useRenewalText({ ko, en, ja, vi, es })
</script>
